module.exports = __webpack_public_path__ + "img/dopeinterview.57df4a99.png";